import { fitBetween } from './fitBetween.js';

/** Linear interpolation — returns the value `t` of the way between `min` and `max`. */
export const lerp = (min: number, max: number, t: number): number =>
  min + (max - min) * t;

/** Inverse linear interpolation — returns how far `value` lies between `min` and `max` as a fraction. */
export const inverseLerp = (min: number, max: number, value: number): number =>
  (value - min) / (max - min);

/**
 * Remaps `value` from the input range `[inMin, inMax]` to the output range
 * `[outMin, outMax]`, clamping the result to the output range so values outside
 * the input range do not extrapolate.
 */
export const interpolateClamped = (
  value: number,
  inMin: number,
  inMax: number,
  outMin: number,
  outMax: number,
): number => {
  const fraction = inverseLerp(inMin, inMax, value);
  const clampedFraction = fitBetween(fraction, 0, 1);
  return lerp(outMin, outMax, clampedFraction);
};
